import type { GenericMultiSelectOption } from '@shared/components/ui/custom';

export enum FacetedFilterOperator {
  IS = 'IS',
  NOT = 'IS_NOT',
}

// Using NOT for display purposes and mapping to IS_NOT for the backend

export const FacetedFilterOperatorLabel: Record<FacetedFilterOperator, string> = {
  [FacetedFilterOperator.IS]: 'IS',
  [FacetedFilterOperator.NOT]: 'NOT',
};

export type BaseField = {
  field: string;
  count?: number;
  values?: string[];
  label?: string;
  value: string;
  selected?: boolean;
  operator?: string | FacetedFilterOperator;
  key: string;
};

export type FilterPill = Pick<BaseField, 'field' | 'operator' | 'value'>;

export type FacetedFilter = {
  operator?: string | FacetedFilterOperator;
  label: string;
  options: GenericMultiSelectOption[];
  key: string;
  selected: string[];
};

export type FilterGridRow = (FacetedFilter | undefined)[];

export type FilterFieldValue = {
  operator: FacetedFilterOperator;
  values: string[];
  addedWithZeroValues?: boolean;
};

export type ParsedFilters = Record<string, FilterFieldValue>;

export type SetFilterFormValue = (
  name: string,
  value: string[] | FilterFieldValue | boolean | FacetedFilterOperator | undefined,
) => void;

export interface ModalPosition {
  left: number;
  top: number;
}

export interface MetadataField {
  label: string;
  value: string | null;
}

export interface ActivityDetailsLevel {
  level: string;
  displayTitle: string;
  children?: ActivityDetailsLevel[];
  details?: { label: string; value: string | null }[];
}

export interface FileFindingsActionsProps {
  id: string;
  disableExport?: boolean;
  isExporting?: boolean;
  onExport?: () => Promise<void>;
}
